import _ from 'lodash';
import constants from '../../../../config/constants';
import { generateDeliveryText } from '../../../../utils/hooks/useCurrentDeliveryText';
import { getPriceToNumber } from '../../../../utils/PriceHelpers';
import { processStoreId } from '../DeliveryOptions.Helper';
import { formatSlotDate, getLocaleTime, pad } from '../utils';

const { MONTHS, AVAILABILITY_PICKUPINSTORE, AVAILABILITY_OUTOFSTOCK } = constants;

function buildPickupItem({ title, cost, storeId, storeName }, tenant) {
  const raw = typeof cost === 'string' ? cost.replace(/[^\d.,]/g, '') : cost;

  const numCost = typeof raw === 'string' ? getPriceToNumber(raw, tenant) : raw;

  return {
    title,
    price: !numCost || Number.isNaN(numCost) ? 'Gratis' : cost,
    storeId,
    storeName,
    show: true,
    isDateRange: false,
  };
}

const getSelectedPickupInStoreDetails = (selectedStore, regionCode) => {
  const now = new Date(getLocaleTime(regionCode));
  const today = now.getDate();
  const { storeId, storeName, earliestAvailableSlot, deliverySlots = [] } = selectedStore;
  const earliestDate = Number(_.get(earliestAvailableSlot, 'slotDate.date', 0));
  const earliestMonth = _.get(earliestAvailableSlot, 'slotDate.month', '');

  const result = [];

  if (earliestDate === today) {
    result.push(
      buildPickupItem({
        title: 'Retira hoy',
        cost: earliestAvailableSlot.cost,
        storeId,
        storeName,
      })
    );
    const nextSlot = deliverySlots.find((slot) => Number(_.get(slot, 'slotDate.date', 0)) !== today);
    if (nextSlot) {
      const d = Number(_.get(nextSlot, 'slotDate.date', 0));
      const m = _.get(nextSlot, 'slotDate.month', '');
      result.push(
        buildPickupItem({
          title: `Retira a partir del ${formatSlotDate(d, m)}`,
          cost: nextSlot.cost,
          storeId,
          storeName,
        })
      );
    }
  } else {
    result.push(
      buildPickupItem({
        title: `Retira a partir del ${formatSlotDate(earliestDate, earliestMonth)}`,
        cost: earliestAvailableSlot.cost,
        storeId,
        storeName,
      })
    );
  }

  return result;
};

const processPickupInStoreSlots = (listOfStores, regionCode) => {
  const currentLocaleTime = getLocaleTime(regionCode);
  const currentDate = new Date(currentLocaleTime).getDate();

  const result = listOfStores.map((store) => {
    const earliestAvailableSlotDate = Number(_.get(store, 'earliestAvailableSlot.slotDate.date', 0));
    const earliestAvailableSlotMonth = _.get(store, 'earliestAvailableSlot.slotDate.month', '').toLowerCase();
    const earliestAvailableSlotInfo =
      earliestAvailableSlotDate === currentDate
        ? 'A partir de hoy'
        : `A partir del ${pad(earliestAvailableSlotDate)}/${MONTHS[earliestAvailableSlotMonth]}`;
    return {
      ...store,
      earliestAvailableSlotInfo,
    };
  });
  return result;
};

const getPickupInStoreSlots = async ({ regionCode, storePickUp }) => {
  const stores = _.get(storePickUp, 'data.storePickUp.listOfStores', []);
  if (!stores || stores.length === 0) {
    return [];
  }
  const result = processPickupInStoreSlots(stores, regionCode);
  if (result && Array.isArray(result) && result.length > 0) {
    return result;
  }
  return [];
};

const getPickupInStoreData = async ({
  comuna,
  regionCode,
  setComunaName,
  setPickupInStoreData,
  setSelectedStoreId,
  setSelectedDeliveryOption,
  setParentStateName,
  setDeliveryError,
  storePickUp,
  setIsMapView,
  setSelectedStoreDetails,
  setSelectedStoreName,
  zoneConfig,
  isFreeShippingApplicable,
  isDefaultComuna,
  outOfStock,
  labelsData,
  setTextGenerated,
}) => {
  if (comuna && !_.isEmpty(comuna)) {
    const comunaName = comuna?.name || '';
    const parentStateName = comuna?.parentStateName || '';
    setParentStateName(parentStateName);
    const ccData = await getPickupInStoreSlots({
      regionCode,
      storePickUp,
    });
    if (ccData && Array.isArray(ccData) && ccData.length > 0) {
      setDeliveryError(AVAILABILITY_PICKUPINSTORE, false);
      setPickupInStoreData(ccData);
      const storeId = _.get(ccData, '[0].storeId', null);
      setSelectedStoreId((prev) => ({
        ...prev,
        [AVAILABILITY_PICKUPINSTORE]: prev[AVAILABILITY_PICKUPINSTORE] || ccData[0].storeId,
      }));
      setComunaName(_.get(comuna, 'name', ''));
      processStoreId({
        storeId,
        storesData: ccData,
        setSelectedStoreDetails,
        setSelectedStoreName,
        regionCode,
        zoneConfig,
        isFreeShippingApplicable,
        setSelectedDeliveryOption,
        parentStateName,
        type: AVAILABILITY_PICKUPINSTORE,
        isDefaultComuna,
        outOfStock,
        textDictionary: labelsData,
        setTextGenerated,
      });
    } else {
      setComunaName(_.get(comuna, 'name', ''));
      setPickupInStoreData([]);
      setDeliveryError(AVAILABILITY_PICKUPINSTORE, true, 'NO_PICKUP_SLOTS');
      setIsMapView(false);
      const selectionData = {
        selectedType: 'No disponible',
        date: '',
        month: '',
        price: '',
        locationName: comunaName.toLowerCase(),
        storeName: '',
        politicalId: '',
        storeId: '',
        isError: true,
        isFreeShippingApplicable: false,
        parentStateName,
        deliveryOptionType: AVAILABILITY_PICKUPINSTORE,
      };
      const stockText = generateDeliveryText(
        selectionData,
        AVAILABILITY_OUTOFSTOCK,
        labelsData,
        AVAILABILITY_PICKUPINSTORE
      );
      setTextGenerated((prev) => ({ ...prev, [AVAILABILITY_PICKUPINSTORE]: stockText }));

      setSelectedDeliveryOption(selectionData);
    }
  }
};

export {
  buildPickupItem,
  getPickupInStoreData,
  getPickupInStoreSlots,
  getSelectedPickupInStoreDetails,
  processPickupInStoreSlots,
};
